import clsx from 'clsx';
import {LabelHTMLAttributes, ReactNode} from 'react';
import styles from './styles.module.scss';

export type ILabel = ReactNode | string | null;

interface ILabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    label?: ILabel;
    inputFilled?: boolean;
    withRequiredMark?: boolean;
    labelStyles?: string[];
}

const Label = ({
    label = null,
    htmlFor = '',
    inputFilled = false,
    withRequiredMark = false,
    labelStyles = []
}: ILabelProps) => {
    return (
        !!label && (
            <label
                htmlFor={htmlFor}
                className={clsx(
                    styles.label,
                    inputFilled && styles.filled,
                    withRequiredMark && styles.withMark,
                    ...labelStyles
                )}
            >
                {label}
                {withRequiredMark && <span className={styles.mark}>{'\u00A0'}*</span>}
            </label>
        )
    );
};

export default Label;
